module.exports = __webpack_public_path__ + "static/media/0034.27686829.png";